<div
  class="navbar-top"
  [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
  *ngIf="isNavbarTopEnabled">
  <div class="logo" *hasFrontConfigurations="[frontConfiguration.LAYOUT_MAIN_LOGO]">
    <img src="assets/images/logos/logo_beplic_blanco.png" />
  </div>
  <div class="buttons">
    <button
      mat-icon-button
      class="toggle-sidebar-folded"
      (click)="toggleSidebarFolded()"
      fxHide.lt-lg>
      <mat-icon class="secondary-text">menu</mat-icon>
    </button>

    <button
      mat-icon-button
      class="toggle-sidebar-opened"
      (click)="toggleSidebarOpened()"
      fxHide.gt-md>
      <mat-icon class="secondary-text">arrow_back</mat-icon>
    </button>
  </div>
</div>

<div
  class="navbar-scroll-container"
  [ngClass]="fuseConfig.layout.navbar.primaryBackground"
  fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{ suppressScrollX: true }">
  <div
    class="user"
    fxLayout="column"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
    *ngIf="isNavbarTopEnabled">
    <div class="h3 username">
      {{ user.firstName == null ? '' : user.firstName }}
      {{ user.lastName == null ? '' : user.lastName }}
    </div>
    <div class="h5 email hint-text mt-8">
      {{ user.email == null ? '' : user.email }}
    </div>
    <div
      class="avatar-container"
      [ngClass]="fuseConfig.layout.navbar.primaryBackground">
      <img
        class="avatar"
        [src]="
          profileImageUrl && profileImageUrl !== ''
            ? profileImageUrl
            : 'assets/images/avatars/profile.jpg'
        " />
    </div>
  </div>

  <div class="navbar-content">
    <fuse-navigation
      class="material2"
      layout="vertical"
      [navigation]="navigation"></fuse-navigation>
  </div>
</div>
